import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>GymsSync</h3>
          <p>The best gym management software in India</p>
        </div>
        <div className="footer-section">
          <h4>Product</h4>
          <ul>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/coming-soon">App</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Resources</h4>
          <ul>
            <li><Link to="/blog/top-10-gym-management-software-india">Blog</Link></li>
            <li><Link to="/coming-soon">Support</Link></li>
            <li><Link to="/coming-soon">Documentation</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/coming-soon">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 GymsSync. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

